import { createDetailedValidator } from 'typecheck.macro';
import { makeAlgoliaIndex } from '../../schema/public-algolia/AlgoliaIndex';
import { useAlgoliaAutoComplete } from './useAutoComplete';

export const useAutoCompleteCulturalBackgrounds = (input?: string) =>
  useAlgoliaAutoComplete(CulturalBackgroundIndex, input).map(hit => ({
    label: hit.cultural_background,
    value: hit.cultural_background,
  }));

const CulturalBackgroundIndex = makeAlgoliaIndex(
  'CulturalBackgrounds',
  // eslint-disable-next-line camelcase
  createDetailedValidator<{ cultural_background: string }>(),
);
